// ////////////////////////////////////////////////////////////////////////////////
// Fichier pour la gestion du bandeau VB + cookies
// ////////////////////////////////////////////////////////////////////////////////
// Creation : 30/05/2022 CGR
// ////////////////////////////////////////////////////////////////////////////////



// //////////////////////////////////
// Imports

// Imports system
import React from 'react';


// Bouton
const Credits = () => {

    // rendu
    return (
        <div id = 'credits'>
            <p>powered by</p>
            <img src={`/images/asylum.png`}></img>
        </div>
    )
}

export default Credits;
